import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';
import ReviewSpaceRentalTable from '../elements-tables/review-space-rental-table';
import AddOnsTable from '../app-main/components/reduxForms/fieldSets/AddOnsTable/add-ons-table';
import PayoutTable from '../elements-tables/payout-table';
import SendOfferFormContainer from '../app-main/components/reduxForms/forms/SendOfferForm/SendOfferFormContainer';
import { normalizeContracts, priceBreakdownObject } from '../app-bookings-request/forms/bookingUtil';

export default class CustomOfferReviewPage extends Component {
  componentDidMount () {
    window.scrollTo(0, 0);
    this.props.scrollToTop();
  }

  render () {
    const {
      booking,
      navigateBack,
      contract,
      ssoId,
      payloadData,
      redirectToInboxDetails,
      isHostUpdate,
      isEditOffer,
      iosWebView,
      accessToken
    } = this.props;

    const contractsQuote = get(contract, 'quote.children', []);
    contractsQuote.master = get(contract, 'quote.master', {});
    const normalizedContracts = normalizeContracts(contractsQuote);
    const priceBreakdown = priceBreakdownObject(normalizedContracts);
    const guestName = get(booking, 'guest.name.first', '');
    const contractData = get(contract, 'data.contracts', []);
    const wasTSAccepted = get(
      normalizedContracts,
      'spaceRentalContract.meta.risk.host_social_events_policy_accepted',
      false
    );
    const showTSWarning = get(
      normalizedContracts,
      'spaceRentalContract.meta.risk.host_social_events_policy_agreement_required',
      false
    ) && !isHostUpdate && !wasTSAccepted;

    const {
      cleaningFee,
      spaceRentalSubtotal,
      spaceRentalTotal,
      currency,
      currencySymbol,
      itemsArray,
      addOnsTotal,
      total,
      hostFee,
      guestFee,
      hostPayout,
      guestPayment,
      discounts,
      contractBooking,
      hostAddOnsSummary = {}
    } = priceBreakdown;
    const masterCalc = get(contractsQuote, 'master.calculations', {});
    const hasConciergeItems = get(masterCalc, 'concierge_add_ons_summary');

    const displayAddOns = get(masterCalc, 'host_add_ons_summary') ||
      (addOnsTotal && !hasConciergeItems);

    return (
      <div className="review-step flex-one" data-testing-id="review-page">
        <div className="review-page-panels flex column space-between">
          <div>
            <ReviewSpaceRentalTable
              cleaningFee={cleaningFee}
              subtotal={spaceRentalSubtotal}
              total={spaceRentalTotal}
              currency={currency}
              masterContract={normalizedContracts?.masterContract}
            />

          { !!displayAddOns &&
              <AddOnsTable
                isReviewPage
                itemsArray={itemsArray}
                currencySymbol={currencySymbol}
                currency={currency}
                ssoId={ssoId}
                addOnsTotal={addOnsTotal}
                hostAddOnsSummary={hostAddOnsSummary}
                contract={contractsQuote}
                masterContract={normalizedContracts.masterContract}
              />
            }

            <PayoutTable
              currency={currency}
              spaceRentalTotal={spaceRentalTotal}
              addOnsTotal={addOnsTotal}
              hostAddOnsSummary={hostAddOnsSummary}
              total={total[ssoId]}
              hostFee={hostFee}
              guestFee={guestFee}
              hostPayout={hostPayout}
              guestPayment={guestPayment}
              discounts={discounts}
              iosWebView={iosWebView}
              itemsArray={itemsArray}
              masterContract={get(contractsQuote, 'master', {})}
            />

            <SendOfferFormContainer
              guestName={guestName}
              navigateBack={navigateBack}
              payloadData={payloadData}
              redirectToInboxDetails={redirectToInboxDetails}
              isHostUpdate={isHostUpdate}
              isEditOffer={isEditOffer}
              accessToken={accessToken}
              guestPayment={guestPayment}
              currency={currency}
              booking={contractBooking}
              contract={contract}
              iosWebView={iosWebView}
              contractData={contractData}
              showTSWarning={showTSWarning}
            />
          </div>
        </div>
      </div>
    );
  }
}

CustomOfferReviewPage.propTypes = {
  booking: PropTypes.object,
  payloadData: PropTypes.object,
  navigateBack: PropTypes.func,
  contract: PropTypes.object,
  ssoId: PropTypes.string,
  redirectToInboxDetails: PropTypes.func,
  scrollToTop: PropTypes.func,
  isHostUpdate: PropTypes.bool,
  isEditOffer: PropTypes.bool,
  iosWebView: PropTypes.bool,
  accessToken: PropTypes.string
};
